<template>
  <div class="drainage" v-loading="loading">
    <div>
      <div class="tabCard">
        <!-- option -->
        <ul class="optionList clearfix">
          <li class="option-item">
            <span class="label">区域</span>
            <el-select v-model="regionValue" placeholder="请选择" multiple collapse-tags @change="selectRegions">
              <el-option v-for="item in regionOptions" :key="item.value" :label="item.value" :value="item.value">
              </el-option>
            </el-select>
          </li>
          <li class="option-item">
            <span class="label">是否合格</span>
            <el-select v-model="ifQualified" placeholder="请选择">
              <el-option v-for="item in ifQualifieds" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </li>
          <li class="option-item">
            <span class="label">检查时间</span>
            <el-date-picker unlink-panels v-model="samplingdate" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                            type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                            :picker-options="pickerOptions1">
            </el-date-picker>
          </li>
          <li class="option-item">
            <span class="label">单位/项目名称</span>
            <el-input v-model="likeNameValue" placeholder="模糊查询"></el-input>
          </li>
          <li class="option-item">
            <el-button type="primary" @click="queryData">查询</el-button>
            <el-button type="primary" @click="showAddDialog" v-show="decidePower('排水户检查-编辑')">添加</el-button>
          </li>

        </ul>
        <!-- table -->
        <!-- 表格 -->
        <div class="table-wrapper">
          <el-table :data="tableData" stripe style="width: 100%" :height="tableHeight"
                    :header-cell-style="tableHeaderColor">
            <el-table-column prop="num" label="序号" width="50">
            </el-table-column>
            <el-table-column prop="region" label="区域">
            </el-table-column>
            <el-table-column prop="companyname" label="排水户名称">
            </el-table-column>
            <el-table-column prop="projectname" label="项目名称">
            </el-table-column>
            <el-table-column prop="ifqualified" label="检查是否合格">
            </el-table-column>
            <el-table-column prop="samplingdate" :formatter="dateFormat" label="检查时间">
            </el-table-column>
            <el-table-column prop="details" label="排水户详情">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click='handleToInfo(scope.row)'>排水户详情</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="oprate" label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click='showDetailsDialog(scope.row)'>详情</el-button>
                <el-button type="text" size="small" @click='confirms(scope.row)' v-show="decidePower('排水户检查-编辑')">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--分页-->
          <div class="block" style="text-align:right;margin-top: 20px;">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page.sync="currentPage" :page-sizes="[20, 50, 80, 100]" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!--详情弹框-->
    <el-dialog title="排水户检查详情" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="排水户名称" :label-width="formLabelWidth">
          <el-input type="text" v-model="form.companyname" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="项目名称" :label-width="formLabelWidth">
          <el-input type="text" v-model="form.projectname" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="检查是否合格" :label-width="formLabelWidth">
          <el-input type="text" v-model="form.ifqualified" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="检测单位" :label-width="formLabelWidth">
          <el-input type="text" v-model="form.testcompany" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="检查时间" :label-width="formLabelWidth">
          <el-date-picker v-model="form.samplingdate" type="date" placeholder="选择日期" :disabled="true">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="采样人员" :label-width="formLabelWidth">
          <el-input type="text" v-model="form.samplingpeople" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="监管内容" :label-width="formLabelWidth">
          <el-input type="text" v-model="form.testproject" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="附件" :label-width="formLabelWidth">
          <div class="form-table">
            <el-table :data="affixDataList" stripe style="width: 100%" :border='false'
                      :header-cell-style="tableHeaderColor">
              <el-table-column prop="num" label="序号" width="50">
              </el-table-column>
              <el-table-column prop="filename" label="文件">
              </el-table-column>
              <el-table-column prop="name" label="操作" width="200">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click='showDialog(scope.row)'>查看</el-button>
                  <el-button type="text" size="small" @click='downFileEvent(scope.row)'>下载</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible = false">返回</el-button>
      </div>
    </el-dialog>
    <!--新建弹框-->
    <el-dialog title="排水户监管" :visible.sync="dialogFormVisible1">
      <el-form :model="form1" :rules="rules" ref="form1">
        <!--<el-form-item label="排水户名称" :label-width="formLabelWidth1">
          <el-input type="text" v-model="form1.companyname"></el-input>
        </el-form-item>-->
        <el-form-item label="单位" :label-width="formLabelWidth1" prop="companyid">
          <el-select v-model="form1.companyid" clearable placeholder="请选择单位" @change="companySelect">
            <el-option v-for="item in companyList" :key="item.id" :label="item.companyname" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目" :label-width="formLabelWidth1" prop="projectid">
          <el-select v-model="form1.projectid" clearable placeholder="请选择项目" :disabled="proDisabled">
            <el-option v-for="item in projectsList" :key="item.projectid" :label="item.projectname"
                       :value="item.projectid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检测单位" :label-width="formLabelWidth1" prop="testcompany">
          <el-input type="text" v-model="form1.testcompany"></el-input>
        </el-form-item>
        <el-form-item label="检查时间" :label-width="formLabelWidth1" prop="samplingdate">
          <el-date-picker v-model="form1.samplingdate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                          placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="采样人员" :label-width="formLabelWidth1" prop="samplingpeople">
          <el-input type="text" v-model="form1.samplingpeople"></el-input>
        </el-form-item>
        <el-form-item label="监管内容" :label-width="formLabelWidth1" prop="testproject">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
          </el-checkbox>
          <div style="margin: 15px 0;"></div>
          <el-checkbox-group v-model="form1.testproject" @change="handleCheckedTestProjectsChange">
            <el-checkbox v-for="testproject in projects" :label="testproject" :key="testproject">{{testproject}}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="是否合格" :label-width="formLabelWidth1" prop="ifQualified">
          <el-select v-model="form1.ifQualified" clearable placeholder="请选择">
            <el-option v-for="item in ifQualifiedOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="附件" :label-width="formLabelWidth1">
          <el-form-item label="" class="upload">
            <el-upload class="upload-demo" action="" :limit="5" :on-exceed="handleExceed" :http-request="uploadAffix"
                       :file-list="affixList">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
            </el-upload>
          </el-form-item>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">返回</el-button>
        <el-button type="primary" @click="submitForm('form1')">确 定</el-button>
      </div>
    </el-dialog>

    <!--查看图片弹框-->
    <!--<el-dialog :visible.sync="dialogVisible" @opened="openedImg()">
      <img id="pic" src="" style='width:100%;height:auto;'>
       <div id="pic" style='background-repeat:no-repeat;background-size:100% auto; background-position:center top;'></div>
    </el-dialog>-->
    <div class="dialog-container" v-show="dialogVisible" id="dialog-container">
      <div class="dialog-content" id="dialog-content">
        <i class="el-icon-close" @click='dialogVisible=false'></i>
        <img id="pic" src="">
      </div>
    </div>
    <!--文件下载窗口-->
    <iframe v-show="false" id="iframe1" frameborder=0 name="iframe1" scrolling=auto src=""></iframe>
  </div>
</template>
<script>
// import pagination from '@/common/pagination/pagination';
//检测项目选项
const testprojectOptions = ['水质', '设施', '内部管理情况'];
export default {
  name: 'MessageMain',
  data() {
    return {
      //加载图标
      loading: true,
      // 上传的文件集合
      uploadFileList: [],
      currentPage: 1,
      total: 0,
      pageSize: 20,
      // 所属大平台单位id
      platformCompanyId: '',        
      // 所属区域
      regionValue: [],
      regionValueD: [], //不可变
      regionsLength: 0, //全局集合长度
      regionsVariableLength: 0, //全局集合长度变量
      //				regionOptions: [{
      //						text: '全部',
      //						value: '全部'
      //					}, {
      //						text: '海陵区',
      //						value: '海陵区'
      //					},
      //					{
      //						text: '姜堰区',
      //						value: '姜堰区'
      //					},
      //					{
      //						text: '医药高新区',
      //						value: '医药高新区'
      //					},
      //					{
      //						text: '高港区',
      //						value: '高港区'
      //					}
      //				],
      regionOptions: [],
      // 采样日期
      samplingdate: [],
      // 模糊查询名称
      likeNameValue: '',
      // 是否合格
      ifQualified: '-1',
      ifQualifieds: [{
        label: '全部',
        value: '-1'
      }, {
        label: '是',
        value: '0'
      }, {
        label: '否',
        value: '1'
      }],
      // 排水户数据列表数据
      tableData: [],
      tableHeight: window.innerHeight - 60 - 40 - 20 - 20 - 150,
      styleObject: {
        height: window.innerHeight - 60 - 40 - 20 - 20 - 80 - 50 - 120 + 'px'
      },
      //详情弹框
      form: {
        companyname: '',
        projectname: '',
        ifqualified: '',
        testcompany: '',
        samplingdate: '',
        samplingpeople: '',
        testproject: []
      },
      //详情附件列表
      affixDataList: [],
      //新建弹框
      form1: {
        companyid: '',
        projectid: '',
        testcompany: '',
        samplingdate: '',
        samplingpeople: '',
        testproject: [],
        ifQualified: ''
      },
      ifQualifiedOptions: [{
        label: '是',
        value: '0'
      }, {
        label: '否',
        value: '1'
      }],
      // 单位集合
      companyList: [],
      // 某单位下的项目集合
      projectsList: [],
      //检测项目全选按钮
      checkAll: false,
      isIndeterminate: true,
      //检测项目
      projects: testprojectOptions,
      //附件上传
      affixList: [],
      formLabelWidth: '120px',
      formLabelWidth1: '120px',
      dialogFormVisible: false,
      dialogFormVisible1: false,
      //查看图片弹框
      dialogVisible: false,
      //展示图片的路径
      imgPath: '',
      //新建弹框中项目下拉框显示
      proDisabled: true,
      pickerOptions1: {
        shortcuts: [{
          text: '最近一个月',
          onClick(picker) {
            var date = new Date();
            var year = date.getFullYear() + "";
            var month = (date.getMonth() + 1) + "";
            // 本月第一天日期
            var begin = year + "-" + month + "-01";
            // 本月最后一天日期    
            var lastDateOfCurrentMonth = new Date(year, month, 0);
            var end = year + "-" + month + "-" + lastDateOfCurrentMonth.getDate();
            var startDay = new Date(begin);
            var endDay = new Date(end);
            picker.$emit('pick', [startDay, endDay]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            var date = new Date();
            var year = date.getFullYear() + "";
            var month = (date.getMonth() + 1) + "";
            //判断如果当前月份小于3月
            if (month < 3) {
              var year1 = year - 1;
              var month1 = 12 + parseInt(month) - 2;
            } else {
              var year1 = year;
              var month1 = month - 2;
            }
            // 本月第一天日期
            var begin = year1 + "-" + month1 + "-01";
            // 本月最后一天日期    
            var lastDateOfCurrentMonth = new Date(year, month, 0);
            var end = year + "-" + month + "-" + lastDateOfCurrentMonth.getDate();
            var startDay = new Date(begin);
            var endDay = new Date(end);
            picker.$emit('pick', [startDay, endDay]);
          }
        }, {
          text: '最近半年',
          onClick(picker) {
            var date = new Date();
            var year = date.getFullYear() + "";
            var month = (date.getMonth() + 1) + "";
            //判断如果当前月份小于6月
            if (month < 6) {
              var year1 = year - 1;
              var month1 = 12 + parseInt(month) - 5;
              if (month1 < 10) {
                month1 = "0" + month1;
              }
            } else {
              var year1 = year;
              var month1 = month - 5;
            }
            // 本月第一天日期
            var begin = year1 + "-" + month1 + "-01";
            // 本月最后一天日期    
            var lastDateOfCurrentMonth = new Date(year, month, 0);
            var end = year + "-" + month + "-" + lastDateOfCurrentMonth.getDate();
            var startDay = new Date(begin);
            var endDay = new Date(end);
            picker.$emit('pick', [startDay, endDay]);
          }
        }]
      },
      //新建表单验证
      rules: {
        //单位名称
        companyid: [{
          required: true,
          message: '请选择单位',
          trigger: 'change'
        }],
        // 项目名称
        projectid: [{
          required: true,
          message: '请选择项目',
          trigger: 'change'
        }],
        //检测单位
        testcompany: [{
          required: true,
          message: '请输入检测单位名称',
          trigger: 'blur'
        }],
        //采样日期
        samplingdate: [{
          required: true,
          message: '请选择采样日期',
          trigger: 'blur'
        }],
        //采样人员
        samplingpeople: [{
          required: true,
          message: '请输入采样人员姓名',
          trigger: 'blur'
        }],
        //检测项目
        testproject: [{
          required: true,
          message: '请至少选择一个检测项目',
          trigger: 'change'
        }],
        //是否合格
        ifQualified: [{
          required: true,
          message: '请至少选择一项',
          trigger: 'change'
        }]
      }
    }
  },
  components: {
    // pagination
  },
  mounted() {
    // 获取所属大平台单位id
    var companyInfo = sessionStorage.getItem('drainage-companyInfo');
    if (companyInfo) {
      this.platformCompanyId = JSON.parse(companyInfo).CompanyId;
    } else {
      this.$message({
        type: 'error',
        message: '登录信息过期，请重新登录'
      });
      this.$router.push({
        path: '/login'
      });
    }       
    this.uploadFileList = [];
    const that = this
    window.onresize = () => {
      return (() => {
        window.tableHeight = window.innerHeight - 60 - 40 - 20 - 20 - 150
        that.tableHeight = window.tableHeight
      })()
    }
    this.init();
  },
  methods: {
    // 修改table header的背景色
    tableHeaderColor({
                       row,
                       column,
                       rowIndex,
                       columnIndex
                     }) {
      if (rowIndex == 0) {
        return 'background-color: #e2e7eb;'
      }
    },
    init() {
      this.getNowTime();
      this.regionOptions = this.filterRegion();
      this.regionsLength = this.regionOptions.length;
      this.regionsVariableLength = this.regionOptions.length;
      var i;
      for (i in this.regionOptions) {
        this.regionValue.push(this.regionOptions[i].value);
      }
      this.regionValueD = this.regionValue;
      //				this.regionValue = this.regionOptions[0].value;
      this.queryData();
    },
    // 设置默认日期
    getNowTime() {
      var dateArray = this.getMonthFirsetLastDay();
      var startDay = this.time2YMD(new Date(dateArray[0]).getTime());
      var endDay = this.time2YMD(new Date(dateArray[1]).getTime());
      this.samplingdate = [startDay, endDay];
    },
    //区域选项发生变化时执行此方法
    selectRegions(val) {
      if (val.length > 0) {
        //										debugger;
        //选择后集合不包括全选'-1'且选择后的长度等于原始长度减去1并且变量长度等于原始长度，说明第一次点击全选，应清空
        if (val.indexOf('全部') == -1 && this.regionsLength - 1 == val.length && this.regionsVariableLength == this.regionsLength) {
          this.regionValue = [];
        }
        //集合最后一项包含-1说明点击了全选按钮应对全选
        if (val.indexOf('全部') != -1 && '全部' == val[val.length - 1]) {
          this.regionValue = this.regionValueD;
        }
        //如果选择后当前选择为集合最大长度，并且不包含’-1‘，则说明选中了所有项则全选应自动选中
        if (val.indexOf('全部') == -1 && val.length == this.regionsLength - 1 && this.regionsVariableLength != this.regionsLength) {
          this.regionValue = this.regionValueD;
        }
        //如果包含'-1'并且长度小于等于集合的长度则把'-1'从集合中去掉
        if (val.indexOf('全部') != -1 && '全部' != val[val.length - 1] && val.length <= this.regionsLength - 1) {
          var arr = [];
          var x;
          for (x in val) {
            if ('全部' != val[x]) {
              arr.push(val[x]);
            }
          }
          this.regionValue = arr;
        }
        this.regionsVariableLength = this.regionValue.length;
      }
    },
    // 选择所有的单位
    findCompanyInfo() {
      this.companyList = [];
      this.$http.post(this.basePath + '/sewerageUser/findAllCompanyInfo', {
        //  参数
        platformCompanyId: this.platformCompanyId
      }).then((result) => {
        if (result.data.resCode == 1 && result.data.data != '') {
          var resultList = JSON.parse(result.data.data);
          this.companyList = resultList;
        } else {
          console.log('获取单位数据为空！')
        }
      }, (error) => {
        //					alert('error');
        this.$message({
          type: 'error',
          message: 'error!'
        });
      });
    },
    // 选择单位事件
    companySelect(companyId) {
      this.getProjectListByCompanyId(companyId);
      if (this.form1.companyid != '') {
        this.proDisabled = false;
      } else {
        this.proDisabled = true;
      }
    },
    //获取项目列表
    getProjectListByCompanyId(companyId) {
      this.projectsList = [];
      this.$http.post(this.basePath + '/sewerageUser/findProjectsByCompanyIdAndLS', {
        companyId: companyId
      }).then((result) => {
        if (result.data.resCode == 1 && result.data.data != '') {
          var resultList = JSON.parse(result.data.data);
          this.projectsList = resultList;
        } else {
          //						alert('获取数据为空！')
          this.$message({
            type: 'error',
            message: '获取数据为空!'
          });
        }
      }, (error) => {
        //					alert('error');
        this.$message({
          type: 'error',
          message: 'error!'
        });
      });
    },
    //详情页跳转
    handleToInfo(valObj) {
      var companyId = valObj.comid;
      var projectId = valObj.proid;
      this.$router.push({
        name: 'messageInfo',
        params: {
          companyId: companyId,
          projectId: projectId
        }
      });
    },
    //打开图片弹框
    showDialog(row) {
      this.viewPic(row);
      var that = this;
      document.getElementById('pic').setAttribute('src', this.imgPath);
      //				document.getElementById('pic').onload = this.scalingImage(document.getElementById('pic'));
      document.getElementById('pic').onload = function () {  // 打印
        //					that.autoResizeImage(400,400,document.getElementById('pic'));
        //图片宽度
        var picW0 = document.getElementById('pic').naturalWidth;
        //图片高度
        var picH0 = document.getElementById('pic').naturalHeight;

        //当前浏览器窗口宽度
        var winW = document.body.clientWidth;
        //当前浏览器窗口内部高度
        var winH = document.body.clientHeight;
        if (picW0 > 1600 || picH0 > 940) {
          var whObj = that.scalingImage(picW0, picH0, 1600, 940);
          var objWidth = whObj.width;
          var objHeight = whObj.height;
          var widthC = (objWidth - 20) + 'px';
          var heightC = (objHeight - 80) + 'px';
          var picObj = document.getElementById('pic');
          picObj.style.width = widthC;
          picObj.style.height = heightC;
        } else {
          //						var picObj = document.getElementById('pic');
          document.getElementById('pic').style.width = picW0 + 'px';
          document.getElementById('pic').style.height = picH0 + 'px';
        }
        setTimeout(() => {
          var picW = document.getElementById('pic').width;
          var picH = document.getElementById('pic').height;
          //弹框左边距
          var leftW = (winW - picW) / 2;
          //弹框上边距
          var topH = (winH - picH) / 2;
          //						document.getElementById('dialog-content').style.width = (picW + 20) + 'px';
          //						document.getElementById('dialog-content').style.height = (picH + 51) + 'px';
          document.getElementById('dialog-content').style.width = picW + 'px';
          document.getElementById('dialog-content').style.height = picH + 'px';
          document.getElementById('dialog-content').style.left = leftW + 'px';
          document.getElementById('dialog-content').style.top = topH + 'px';
        }, 10);
      };
      this.dialogVisible = true;
      $('#dialog-container').unbind('click').click(function () {
        that.dialogVisible = false;
      });
    },
    scalingImage(imgWidth, imgHeight, containerWidth, containerHeight) {
      var containerRatio = containerWidth / containerHeight;
      var imgRatio = imgWidth / imgHeight;

      if (imgRatio > containerRatio) {
        imgWidth = containerWidth;
        imgHeight = containerWidth / imgRatio;
      } else if (imgRatio < containerRatio) {
        imgHeight = containerHeight;
        imgWidth = containerHeight * imgRatio;
      } else {
        imgWidth = containerWidth;
        imgHeight = containerHeight;
      }
      return {
        width: imgWidth,
        height: imgHeight
      };
    },
    // 文件下载
    downFileEvent(row) {
      var path = this.basePath + '/fileController/downloadFile/' + row.filepath;
      document.getElementById('iframe1').setAttribute('src', path);
    },
    //查看图片
    viewPic(row) {
      var iPath = this.basePath + '/fileController/download/' + row.filepath;
      this.imgPath = iPath;
    },
    //删除记录
    deleteItem(valObj) {
      this.$http.post(this.basePath + '/sewerageUser/deleteSewerageInspectById/', {
        //  参数
        mainId: valObj.insid,
      }).then((result) => {
        if (result.data.resCode == 1 && result.data.data != '') {
          //						alert('删除成功');
          setTimeout(() => {
            this.queryData();
          }, 500);
        } else {
          //						alert(result.data.msg);
          this.$message({
            type: 'error',
            message: result.data.msg
          });
        }
      }, (error) => {
        //					alert('删除失败');
        this.$message({
          type: 'error',
          message: '删除失败!'
        });
      });
    },
    getAffixFileList(id) {
      this.$http.post(this.basePath + '/sewerageUser/getSewerageInspectById/', {
        //  参数
        id: id,
      }).then((result) => {
        this.affixDataList = [];
        if (result.data.resCode == 1 && result.data.data != '') {
          var resultList = JSON.parse(result.data.data);
          if (resultList.fileList != '') {
            var fileList = JSON.parse(resultList.fileList);
            for (var i = 0; i < fileList.length; i++) {
              var dd = fileList[i];
              dd.num = (i + 1);
              this.affixDataList.push(dd);
            }
          }
        } else {
          //						alert(result.data.msg);
          this.$message({
            type: 'error',
            message: result.data.msg
          });
        }
      }, (error) => {
        //					alert('获取失败');
        this.$message({
          type: 'error',
          message: '获取失败'
        });
      });
    },
    //打开详情弹框
    showDetailsDialog(row) {
      this.form.companyname = row.companyname;
      this.form.projectname = row.projectname;
      this.form.ifqualified = row.ifqualified;
      this.form.testcompany = row.testcompany;
      this.form.samplingdate = this.time2YMD(row.samplingdate.time);
      this.form.samplingpeople = row.samplingpeople;
      this.form.testproject = row.testproject;
      this.dialogFormVisible = true;
      this.getAffixFileList(row.insid)
    },
    //打开新建弹框
    showAddDialog() {
      this.dialogFormVisible1 = true;
      this.proDisabled = true;
      // 重置表单验证
      if (this.$refs['form1'] !== undefined) {
        this.$refs['form1'].resetFields();
      }
      //清空form1
      this.form1.companyid = '';
      this.form1.projectid = '';
      this.form1.testcompany = '';
      this.form1.testproject = [];
      this.form1.samplingpeople = '';
      this.form1.samplingdate = '';
      this.form1.ifQualified = '';
      this.affixList = [];
      // 选择单位，然后选择其下某个项目
      this.findCompanyInfo();
    },
    //新建表单验证
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.toNewDrainage();
        } else {
          return false;
        }
      });
    },
    //新建方法
    toNewDrainage() {
      //				if(this.uploadFileList == '') {
      //					alert('请上传检测文件');
      //					return false;
      //				}
      this.dialogFormVisible1 = false;
      this.$http.post(this.basePath + '/sewerageUser/createSewerageInspect', {
        //  参数
        projectid: this.form1.projectid,
        testCompany: this.form1.testcompany,
        testProject: this.form1.testproject,
        samplingPeople: this.form1.samplingpeople,
        samplingDate: this.form1.samplingdate,
        ifQualified: this.form1.ifQualified,
        fileDataListJson: JSON.stringify(this.uploadFileList)
      }).then((result) => {
        if (result.data.resCode == 1 && result.data.data != '') {
          this.$message({
            type: 'success',
            message: '新建成功!'
          });
          //						alert('新建成功');
          //将查询条件设置为默认
          this.likeNameValue = '';
          this.regionValue = this.regionValueD;
          this.ifQualified = '-1';
          this.getNowTime();
          setTimeout(() => {
            this.queryData();
          }, 500);
        } else {
          //						alert(result.data.msg);
          this.$message({
            type: 'error',
            message: result.data.msg
          });
        }
      }, (error) => {
        this.$message({
          type: 'error',
          message: '新建失败!'
        });
        //					alert('新建失败');
      });
    },
    //多选框全选按钮事件
    handleCheckAllChange(val) {
      this.form1.testproject = val ? testprojectOptions : [];
      this.isIndeterminate = false;
    },
    //多选框选项发生变化时触发的事件
    handleCheckedTestProjectsChange(val) {
      let checkedCount = val.length;
      this.checkAll = checkedCount === this.projects.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.projects.length;
    },
    //附件选择多于5个弹框
    handleExceed(files, fileList) {
      //				alert(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
      this.$message({
        type: 'error',
        message: `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`
      });
    },
    // 上传附件
    uploadAffix(param) {
      this.publicFileUpload('affix', param);
    },
    /**
     * 文件上传公共方法
     * @param  {[type]} fileType [区分单位文件还是项目文件]
     * @param  {[type]} param    [description]
     * @return {[type]}          [description]
     */
    publicFileUpload(fileType, param) {
      var that = this;
      var maxSize = 10 * 1024 * 1024;
      var fileObj = param.file;
      var fileName = fileObj.name;
      var fileSize = fileObj.size;
      var extension = fileName.substring(fileName.lastIndexOf('.'), fileName.length).toLowerCase();
      if ((extension == ".jpg" || extension == ".png") && fileSize < maxSize) {
        var data = new FormData();
        var hz = fileName.substring(fileName.length - 4, fileName.length);
        var filePathName = new Date().getTime() + '_drainage' + hz;
        // 修改上传图片名称
        data.append("file", fileObj, filePathName);
        // 保存文件对象
        // 文件类型用filetype进行区分（）
        // todo
        var fileObj = {
          filepath: filePathName,
          filename: fileName,
          filetype: fileType //文件类型（单位？项目？）
        }
        $.ajax({
          url: this.basePath + '/fileController/upload/single',
          type: 'POST',
          cache: false,
          data: data,
          processData: false,
          contentType: false,
          success: function (res) {
            if (res.resCode == 1) {
              that.uploadFileList.push(fileObj);
            }
          }
        });
      } else {
        //					alert('请选择jpg、png格式，且小于10M的文件');
        this.$message({
          type: 'error',
          message: '请选择jpg、png格式，且小于10M的文件'
        });
        return;
      }
    },
    // 查询排水户数据列表
    queryData() {
      this.loading = true;
      this.tableData = [];
      var arr = [];
      if (this.regionValue.indexOf('全部') != -1) {
        var x;
        for (x in this.regionOptions) {
          if ('全部' != this.regionOptions[x].value) {
            arr.push(this.regionOptions[x].value);
          }
        }
      } else {
        arr = this.regionValue;
      }
      this.$http.post(this.basePath + '/sewerageUser/findSewerageInspectList/' + this.currentPage + '/' + this.pageSize, {
        //  参数
        platformCompanyId: this.platformCompanyId,
        likeName: this.likeNameValue,
        region: arr,
        ifQualified: this.ifQualified,
        startDate: this.samplingdate[0],
        endDate: this.samplingdate[1]
      }).then((result) => {
        if (result.data.resCode == 1 && result.data.data != '') {
          var resultList = JSON.parse(result.data.data);
          this.total = resultList.total;
          for (var i = 0; i < resultList.list.length; i++) {
            var resultObj = resultList.list[i];
            if (resultObj.ifqualified == '0') {
              resultObj.ifqualified = '是';
            } else {
              resultObj.ifqualified = '否';
            }
            resultObj.num = (i + 1);
            this.tableData.push(resultObj);
          }
        } else {
          //						alert(result.data.msg)
          this.$message({
            type: 'error',
            message: result.data.msg
          });
        }
        setTimeout(() => {
          this.loading = false;
        }, 500);
      }, (error) => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        //					alert('排水户检查数据异常');
        this.$message({
          type: 'error',
          message: '排水户检查数据异常'
        });
      });
    },
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      } else {
        return this.time2YMD(date.time);
      }
    },
    handleSizeChange(val) {
      this.pageSize = Number(`${val}`);
      this.queryData();
    },
    handleCurrentChange(val) {
      this.currentPage = Number(`${val}`);
      this.queryData();
    },
    //删除确认弹框
    confirms(val) {
      this.$confirm('此操作将永久删除该条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteItem(val);
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
}
</script>

<style lang="stylus" scoped>
  .drainage >>> .el-tabs__nav.is-stretch {
    display: inherit;
  }

  .drainage >>> .el-tabs--card > .el-tabs__header .el-tabs__nav,
  .el-tabs--card > .el-tabs__header .el-tabs__item {
    border: none;
    border-radius: 0;
  }

  .drainage >>> .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #E2E7EB;
  }

  .drainage >>> .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #E2E7EB;
  }

  .drainage >>> .el-tabs__item {
    height: 50px;
    line-height: 50px;
    padding: 0 30px;
    border-radius: 2px 2px 0 0;
    font-size: 15px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;

    &:first-child {
      margin-left: 27px;
    }
  }

  .drainage >>> .el-tabs__item.is-active {
    background: #3E82F7;
    color: #fff;
  }

  .drainage >>> .el-tabs__header {
    margin: 0;
    padding-top: 10px;
  }

  .drainage >>> .label {
    display: inline-block;
    font-size: 12px;
    color: #262626;
    margin-right: 10px;
    line-height: 36px
    width: 90px
  }

  .drainage >>> .el-input {
    flex: 1;
  }

  .drainage >>> .el-input__inner {
    /*width: 100%;*/
    flex: 1;
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    color: #262626;
    border: 1px solid #D3D9DB;
    position: relative;
  }

  .drainage >>> .el-date-editor--daterange.el-input__inner {
    /*width: 100% !important;*/
    flex: 1;
    position: relative;
  }


  .optionList {
    margin: 20px 0 20px 20px;
    display flex;
    .option-item {
      display flex;
      flex: 1;
      width: 23%;
      margin-right: 15px;
      &:last-child {
        float: right;
      }
    }

    .label {
      display: inline-block;
      font-size: 12px;
      color: #262626;
      margin-right: 10px;
    }

    .el-input__inner {
      width: 100%;
      height: 36px;
      line-height: 36px;
      font-size: 12px;
      color: #262626;
      border: 1px solid #D3D9DB;
      position: relative;
    }

    .el-date-editor--daterange.el-input__inner {
      width: 100% !important;
      position: relative;
    }

    /* .el-button--primary {
    background-color: #3E82F7;
    border-color: #3E82F7;
  } */

    .el-button {
      font-size: 12px;
      border-radius: 2px;
    }

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 144px;
    }

    .el-input {
      width: inherit;
    }
  }

  .table-wrapper {
    margin: 0 20px;
    .el-table td,
    .el-table th {
      padding: 6px 0;
    }
    .el-table thead.is-group th {
      background: #fafafa;
    }
    .el-table td {
      border: none;
    }
    .el-table .cell {
      font-size: 12px;
    }
    .el-table thead {
      font-size: 12px;
    }
    .data-wrapper .table-wrapper .el-table .cell {
      color: #666;
    }
    .el-table th {
      background-color: #FAFAFA;
      border-right: 1px solid #ffffff;

      &:last-child {
        border-right: none;
      }
    }
  }

 .el-form-item {
    margin-bottom: 15px;
  }

  .chart-wrapper {
    margin: 0 20px;
    // background-color: #ccc;
  }

  .drainage >>> .el-input.is-disabled .el-input__inner {
    background-color: #ebeef5;
    color: #000 !important;
    cursor: not-allowed;
  }

  .image {
    width: 100%;
    height: auto;
  }

  .drainage >>> .form-table {
    // margin: 0 20px;

    .el-table td,
    .el-table th {
      padding: 6px 0;
    }

    .el-table thead.is-group th {
      background: #fafafa;
    }

    .el-table td {
      border: none;
    }

    .el-table .cell {
      font-size: 12px;
    }

    .el-table thead {
      font-size: 12px;
    }

    .data-wrapper .table-wrapper .el-table .cell {
      color: #666;
    }

    .el-table th {
      background-color: #FAFAFA;
      border-right: 1px solid #ffffff;

      &:last-child {
        border-right: none;
      }
    }
  }

  .drainage >>> .el-dialog__header {
    padding: 20px;
    border-bottom: 1px solid #ccc;
  }

  .drainage >>> .el-dialog__body {
    padding: 15px 20px;
    color: #606266;
    font-size: 14px;
  }

  .drainage >>> .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: oldlace !important;
  }

  .drainage >>> .dialog-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .5);
    z-index: 9999;

    .dialog-content {
      position: absolute;
      width: auto;
      height: auto;
      /*min-height: 100px;
      max-height: 940px;
      min-width: 100px;
      max-width: 1600px;*/
      top: 50px;
      left: 50px;
      bottom: 50px
      right: 50px
      background-color: #fff;
      overflow: hidden;

      img {
        width: auto;
        height: auto;
        /*margin: 41px 10px 10px 10px;*/
      }

      /*关闭按钮*/

      i {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 20px;
        font-weight: 700;
        cursor: pointer;
      }
    }
  }

  .drainage >>> .optionList .el-input__inner {
    width: 180px;
  }
</style>



// WEBPACK FOOTER //
// src/components/drainage/components/drainageMain.vue